var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandshake1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 18,
    viewBox: "0 0 30 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_802_5474)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.00634766,
    y: 0.186157,
    width: 29.9874,
    height: 17.6278,
    rx: 8.81388,
    fill: "#11203A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4668 3.04736L10.3334 3.98067H12.2",
    fill: "#11203A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4668 3.04736L10.3334 3.98067H12.2",
    stroke: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0669 3.51413L20.4583 3.81843C20.2494 3.92283 20.009 3.94516 19.7845 3.88098L17.1184 3.11925C16.9516 3.07159 16.779 3.04738 16.6056 3.04736H13.6661C13.3588 3.04736 13.0562 3.12327 12.7853 3.26827C12.5144 3.41327 12.2834 3.6229 12.113 3.87859L9.86719 7.24736H12.1676C12.3213 7.24736 12.4725 7.20946 12.608 7.13696C12.7435 7.06446 12.8589 6.95959 12.9442 6.83174L13.3233 6.26301C13.4086 6.13517 13.524 6.03029 13.6595 5.95779C13.795 5.88529 13.9463 5.8474 14.0999 5.8474H14.7178C14.902 5.84738 15.0822 5.90197 15.2355 6.00416L22.374 10.7631C22.506 10.8511 22.6187 10.9651 22.7051 11.0982C22.7916 11.2312 22.85 11.3805 22.8768 11.5369C22.9036 11.6933 22.8982 11.8534 22.8609 12.0077C22.8237 12.1619 22.7554 12.3069 22.6602 12.4339L22.6315 12.4721C22.4583 12.703 22.2057 12.8615 21.9224 12.917C21.6392 12.9725 21.3454 12.9211 21.0979 12.7726L17.3336 10.5139",
    fill: "#11203A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0669 3.51413L20.4583 3.81843C20.2494 3.92283 20.009 3.94516 19.7845 3.88098L17.1184 3.11925C16.9516 3.07159 16.779 3.04738 16.6056 3.04736H13.6661C13.3588 3.04736 13.0562 3.12327 12.7853 3.26827C12.5144 3.41327 12.2834 3.6229 12.113 3.87859L9.86719 7.24736H12.1676C12.3213 7.24736 12.4725 7.20946 12.608 7.13696C12.7435 7.06446 12.8589 6.95959 12.9442 6.83174L13.3233 6.26301C13.4086 6.13517 13.524 6.03029 13.6595 5.95779C13.795 5.88529 13.9463 5.8474 14.0999 5.8474H14.7178C14.902 5.84738 15.0822 5.90197 15.2355 6.00416L22.374 10.7631C22.506 10.8511 22.6187 10.9651 22.7051 11.0982C22.7916 11.2312 22.85 11.3805 22.8768 11.5369C22.9036 11.6933 22.8982 11.8534 22.8609 12.0077C22.8237 12.1619 22.7554 12.3069 22.6602 12.4339L22.6315 12.4721C22.4583 12.703 22.2057 12.8615 21.9224 12.917C21.6392 12.9725 21.3454 12.9211 21.0979 12.7726L17.3336 10.5139",
    stroke: "#F5F5F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4668 10.5132L24.3334 8.17993L22.4668 10.5132Z",
    fill: "#11203A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4668 10.5132L24.3334 8.17993",
    stroke: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.06681 10.5135L5.2002 8.64685L7.06681 10.5135Z",
    fill: "#11203A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06681 10.5135L5.2002 8.64685",
    stroke: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.86341 1.18616L4.26948 10.047L1.00635 8.18163",
    fill: "#11203A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86341 1.18616L4.26948 10.047L1.00635 8.18163",
    stroke: "#F5F5F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8053 10.194L10.8549 10.2267C11.28 10.5047 11.3969 11.0705 11.1171 11.4952L9.26705 14.3028C8.98724 14.7275 8.41977 14.8455 7.9947 14.5675L7.9451 14.5348C7.52003 14.2567 7.40309 13.691 7.6829 13.2663L9.53295 10.4587C9.81277 10.034 10.3802 9.91587 10.8053 10.194Z",
    fill: "#11203A",
    stroke: "#F5F5F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8757 12.0172C12.3083 12.3003 12.4287 12.8765 12.1455 13.3092L10.8679 15.2616C10.5848 15.6942 10.0086 15.8146 9.57591 15.5315C9.14327 15.2483 9.0229 14.6721 9.30603 14.2394L10.5837 12.2871C10.8668 11.8544 11.443 11.7341 11.8757 12.0172Z",
    fill: "#11203A",
    stroke: "#F5F5F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1203 13.4596C13.5543 13.7406 13.6781 14.3166 13.3979 14.7512L12.5663 16.0406C12.2861 16.4752 11.7111 16.5988 11.2771 16.3177C10.8431 16.0367 10.7193 15.4606 10.9996 15.0261L11.8311 13.7367C12.1114 13.3021 12.6863 13.1785 13.1203 13.4596Z",
    fill: "#11203A",
    stroke: "#F5F5F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60326 10.1809C9.03726 10.4619 9.16105 11.038 8.88082 11.4725L8.04925 12.762C7.76902 13.1965 7.19402 13.3201 6.76002 13.0389C6.32602 12.7579 6.20224 12.1819 6.48247 11.7473L7.31404 10.4579C7.59427 10.0233 8.16926 9.89981 8.60326 10.1809Z",
    fill: "#11203A",
    stroke: "#F5F5F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1367 1.18616L25.7307 10.047L28.9938 8.18163",
    fill: "#11203A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1367 1.18616L25.7307 10.047L28.9938 8.18163",
    stroke: "#F5F5F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3011 13.1048L20.9004 13.6567C20.6922 13.9436 20.3828 14.1408 20.0349 14.2085C19.6869 14.2762 19.3262 14.2093 19.0256 14.0214L16.3999 12.3804",
    fill: "#11203A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3011 13.1048L20.9004 13.6567C20.6922 13.9436 20.3828 14.1408 20.0349 14.2085C19.6869 14.2762 19.3262 14.2093 19.0256 14.0214L16.3999 12.3804",
    stroke: "#F5F5F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9142 14.4866L19.5009 15.0559C19.29 15.3465 18.9792 15.5489 18.6282 15.6245C18.2771 15.7 17.9106 15.6432 17.5988 15.4651L15.4668 14.2468",
    fill: "#11203A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9142 14.4866L19.5009 15.056C19.29 15.3465 18.9792 15.5489 18.6282 15.6245C18.2771 15.7 17.9106 15.6432 17.5988 15.4651L15.4668 14.2468",
    stroke: "#F5F5F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.714 15.6687L17.3048 16.2941C17.1612 16.5135 16.9468 16.6772 16.6973 16.758C16.4478 16.8388 16.1782 16.8319 15.9331 16.7383L13.1338 15.6687",
    fill: "#11203A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.714 15.6687L17.3048 16.2941C17.1612 16.5135 16.9468 16.6772 16.6973 16.758C16.4478 16.8388 16.1782 16.8319 15.9331 16.7383L13.1338 15.6687",
    stroke: "#F5F5F5",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.80049 7.24668C3.80049 7.37045 3.75133 7.48911 3.66381 7.57662C3.5763 7.66414 3.4576 7.71334 3.33384 7.71334C3.21008 7.71334 3.09138 7.66414 3.00387 7.57662C2.91635 7.48911 2.86719 7.37045 2.86719 7.24668C2.86719 7.12292 2.91635 7.00426 3.00387 6.91674C3.09138 6.82923 3.21008 6.78003 3.33384 6.78003C3.4576 6.78003 3.5763 6.82923 3.66381 6.91674C3.75133 7.00426 3.80049 7.12292 3.80049 7.24668Z",
    fill: "#11203A",
    stroke: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1315 7.24668C27.1315 7.37045 27.0824 7.48911 26.9949 7.57662C26.9074 7.66414 26.7887 7.71334 26.6649 7.71334C26.5411 7.71334 26.4224 7.66414 26.3349 7.57662C26.2474 7.48911 26.1982 7.37045 26.1982 7.24668C26.1982 7.12292 26.2474 7.00426 26.3349 6.91674C26.4224 6.82923 26.5411 6.78003 26.6649 6.78003C26.7887 6.78003 26.9074 6.82923 26.9949 6.91674C27.0824 7.00426 27.1315 7.12292 27.1315 7.24668Z",
    fill: "#11203A",
    stroke: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_802_5474"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.00634766,
    y: 0.186157,
    width: 29.9874,
    height: 17.6278,
    rx: 8.81388,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake1);
export default __webpack_public_path__ + "static/media/handshake 1.6c4d839e8a2899bf2b7994a0928ec90d.svg";
export { ForwardRef as ReactComponent };